<svg
        [attr.height]="size"
        [attr.width]="size"
        viewBox="0 0 25 24"
        xmlns="http://www.w3.org/2000/svg"
>
    <path
            [attr.fill]="color"
            [attr.stroke]="color"
            d="M12.5 3.92993C15.8515 3.92993 19.0878 5.89774 21.3281 9.41821C21.7659 10.1055 21.9999 11.0394 22 11.9983C22 12.9575 21.7661 13.8889 21.3291 14.5706L21.3281 14.5715C20.2039 16.3353 18.8361 17.7081 17.3281 18.6438C15.8201 19.5696 14.1799 20.0598 12.5 20.0598C9.14787 20.0598 5.91172 18.101 3.67188 14.5715L3.51758 14.302C3.17958 13.6502 3.00006 12.833 3 11.9954C3 11.0378 3.23395 10.1058 3.67188 9.41821C4.79649 7.65386 6.16424 6.27974 7.67285 5.34399C9.18046 4.41885 10.8207 3.92993 12.5 3.92993ZM12.5 7.46021C9.98305 7.46021 7.95996 9.49491 7.95996 12.0002C7.96013 14.5054 9.98316 16.5403 12.5 16.5403C15.0168 16.5403 17.0399 14.5054 17.04 12.0002C17.04 9.49491 15.0169 7.46021 12.5 7.46021Z"
    />
    <path
            [attr.fill]="color"
            [attr.stroke]="color"
            d="M12.4996 9.63989C13.7935 9.63989 14.86 10.7064 14.86 12.0002C14.8598 13.2917 13.7957 14.3499 12.4996 14.3499C11.2061 14.3496 10.1502 13.2938 10.15 12.0002C10.15 10.6954 11.2071 9.64011 12.4996 9.63989Z"
    />
</svg>
